class ReviewsIntegrationsService {
  constructor(integration_type, integration_object = null, website_id = null, builder = false) {
    this.integration_type = integration_type;
    this.integration_object = integration_object;
    this.website_id = website_id || window.convertflow?.app?.website?.id;
    this.environment = window?.environment || window.convertflow?.app?.environment
    this.builder = builder;
  }

  client() {
    switch (this.integration_type) {
      case 'Okendo':
        return new OkendoClient({ app_key: window.convertflow?.app?.okendo_storefront_token || this.integration_object?.api_data["app_key"] })
      case 'Yotpo':
        return new YotpoClient({ app_key: window.convertflow?.app?.yotpo_storefront_token || this.integration_object?.api_data["app_key"] })
      case 'ConvertFlow':
        return new ConvertFlowClient({ website_id: this.website_id, environment: this.environment, builder: this.builder })
      default:
        break;
    }
  }

  adaptReview(review) {
    switch (this.integration_type) {
      case 'ConvertFlow':
        return review;
      case 'Yotpo':
        return new ReviewsYotpoAdapter(review);
      case 'Okendo':
        return new ReviewsOkendoAdapter(review);
      default:
        break;
    }
  }

  getStoreReviews(ids = []) {
    return new Promise(async (resolve, reject) => {
      if (this.client() == null) {
        resolve([]);
        return;
      }

      try {
        const reviews = await this.client().getStoreReviews(ids);
        if (!Array.isArray(reviews)) {
          resolve([]);
          return;
        }
        const adaptedReviews = reviews.map((review) => this.adaptReview(review));
        resolve(adaptedReviews);
      } catch (error) {
        resolve([]);
      }
    });
  }

  getReviews(productIds) {
    return new Promise(async (resolve, reject) => {
      let reviews = [];

      for (const productId of productIds) {
        try {
          const productReviews = await this.client().getProductReviews(productId);

          if (!productReviews) {
            continue;
          }

          reviews = reviews.concat(this.adaptReview(productReviews));
        } catch (error) {
          reject(error);
          return;
        }
      }

      resolve(reviews);
    });
  }
}

if (typeof window !== 'undefined' && typeof window.convertflow == 'undefined') {
  window.ReviewsIntegrationsService = ReviewsIntegrationsService;
}
